import "./chargeOnPaymentGatewayPages.scss";
import "../../src-utilities/header";
import "../../src-utilities/footer";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import JustValidate from "just-validate";

gsap.registerPlugin(ScrollTrigger);

const GenerateUniqueID = () => {
  document
    .querySelectorAll(".page-content h2")
    .forEach(function (element, index) {
      var uniqueID = "h2-" + (index + 1);
      element.id = uniqueID;

      var textdaa = element.textContent;

      var classname = "text";
      if (index === 0) {
        classname = "text active-title";
      }

      document
        .querySelector(".title-list")
        .insertAdjacentHTML(
          "beforeend",
          `<li  class='${classname}' data-idd='${uniqueID}'>${textdaa}</a></li>`,
        );
    });
};

const BindEvent = () => {
  document.querySelectorAll(".title-list li").forEach(function (element) {
    element.addEventListener("click", function () {
      var obj = this;
      var datasec = obj.getAttribute("data-idd");

      Array.from(obj.parentElement.children).forEach((child) => {
        child.classList.remove("active-title");
      });
      obj.classList.add("active-title");

      var parent_div = document.getElementById("table");
      var isMobile = window.innerWidth < 1050 && parent_div;

      if (isMobile) {
        parent_div.classList.remove("active");
      }

      var scrollToTarget = () => {
        var targetElement = document.querySelector("#" + datasec);
        if (!targetElement) return;
        var offset = 110;
        var targetScrollPosition =
          targetElement.getBoundingClientRect().top +
          window.pageYOffset -
          offset;
        window.scrollTo({
          top: targetScrollPosition - 20,
          behavior: "smooth",
        });
      };

      if (isMobile) {
        // dropdown collapse transition khatam hone ka wait karo
        parent_div.addEventListener("transitionend", scrollToTarget, {
          once: true,
        });
      } else {
        scrollToTarget();
      }
    });
  });
};

function bloghaddtable() {
  GenerateUniqueID();
  BindEvent();
  BindGSAP();
}

function BindGSAP() {
  let list = document.querySelector(".title-list");
  Array.from(document.querySelectorAll(".main-blog h2")).forEach(
    (element, index, elements) => {
      gsap.from(".main-blog h2", {
        scrollTrigger: {
          trigger: element,
          start: () => {
            return `top 160px`;
          },
          onEnter: () => {
            let id = elements[index].id;
            list
              .querySelector(".active-title")
              ?.classList.remove("active-title");
            list
              .querySelector(`.title-list li[data-idd="${id}"]`)
              .classList.add("active-title");
          },
          onLeaveBack: () => {
            list
              .querySelector(".active-title")
              ?.classList.remove("active-title");
            if (index === 0) return;
            let id = elements[index - 1].id;
            list
              .querySelector(`.title-list li[data-idd="${id}"]`)
              .classList.add("active-title");
          },
        },
      });
    },
  );
}

document.addEventListener("DOMContentLoaded", function () {
  bloghaddtable();
});

// toggle table of content in mobile
const screen_innerwidth = window.innerWidth;
if (screen_innerwidth < 1050) {
  let toc = document.querySelector(
    ".table-of-content h3, .table-of-content .toc-heading",
  );
  let parent_div = document.getElementById("table");
  toc.addEventListener("click", function (e) {
    parent_div.classList.toggle("active");
  });
}

//#region Case Study Form
document.querySelectorAll(".eguide-form-open").length > 0
  ? Array.from(document.querySelectorAll(".eguide-form-open")).map((item) => {
      item.addEventListener("click", openCaseStudyForm);
    })
  : "";

document
  .querySelector("#e-guide-main-form .close-button svg")
  .addEventListener("click", closeCaseStudyForm);

window.addEventListener("keyup", (e) => {
  if (e.key === "Escape") {
    closeCaseStudyForm();
  }
});
function openCaseStudyForm(e) {
  let targetdata = e.currentTarget;
  let pdflink = targetdata.getAttribute("data-pdflink");

  document.getElementById("e_guide_link").value = pdflink;

  document.querySelector("#e-guide-main-form").classList.add("open");
}

function closeCaseStudyForm() {
  document.querySelector("#e-guide-main-form").classList.remove("open");
}

const validate_case_study = new JustValidate("#e-guide-form");

validate_case_study
  .addField("#case-study-fullname", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
  ])
  .addField("#case-study-companyemail", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ]);

let GoogleSendURL =
  "https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec";

let loader = document.querySelector(".loader");

document
  .querySelector("#e-guide-form")
  .addEventListener("submit", async (event) => {
    event.preventDefault();
    if (validate_case_study.isValid == false) {
      return false;
    }

    loader.classList.add("active");

    let formData = new FormData(event.target);
    let fullName = formData.get("lfirstname").split(" ");
    let firstName, lastName;
    [firstName, ...lastName] = fullName;
    lastName = lastName.join(" ");
    let e_guide_link = formData.get("e_guide_link");
    formData.set("lfirstname", firstName);
    formData.set("llastname", lastName);
    formData.append("sendurlvalue", window.location.href);
    formData.append("lsource", "Download-Product-EGuide");
    formData.append("Primary_E_Guide_Link", e_guide_link);

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // Initiate the Sales IQ visitor data
    if (window.$zoho && window.$zoho.salesiq) {
      try {
        $zoho.salesiq.visitor.uniqueid();
        $zoho.salesiq.visitor.name(firstName + " " + lastName);
        $zoho.salesiq.visitor.email(formData.get("lemail"));
        console.log("SalesIQ Name/Email set");
      } catch (error) {
        console.warn("SalesIQ Error:", error);
      }
    }

    let raw = JSON.stringify({
      firstName: formData.get("lfirstname"),
      lastName: formData.get("llastname"),
      email: formData.get("lemail"),
      leadSource: formData.get("lsource"),
      websiteVisitURL: window.location.href,
      primaryCaseStudyLink: formData.get("Primary_E_Guide_Link"),
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    let googleRequestOptions = {
      method: "GET",
      redirect: "follow",
    };
    let request = "?";
    [...formData].forEach(([key, value], index) => {
      request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
    });

    // Request 1: Main Backend
    const backendRequest = fetch(
      "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
      requestOptions,
    );

    // Request 2: Update the Google Sheet Data
    const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

    // Waiting until these request get's completed
    try {
      await Promise.allSettled([backendRequest, googleRequest]);
    } catch (e) {
      console.error("API Error", e);
    }

    // Redirect
    window.location.href =
      "https://products.cyntexa.com/success?downloadEguide";
  });
//#endregion Case Study Form
